export const navigationItems = [
  { label: 'Accueil', href: '/' },
  { label: 'Mes Services', href: '/#services' },
  { label: 'Les CEE', href: '/cee' },
  { label: 'Contact', href: '/#contact' }
];